import { Home, Trophy, Users2, BarChart3, UserRound } from "lucide-react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { ROUTES } from "@/constants/routes";
import { cn } from "@/utils/cn";

const NAV_ITEMS = [
  { to: ROUTES.home, label: "Home", icon: Home },
  { to: ROUTES.matches, label: "Jogos", icon: Trophy },
  { to: ROUTES.groups, label: "Grupos", icon: Users2 },
  { to: ROUTES.ranking, label: "Ranking", icon: BarChart3 },
  { to: ROUTES.profile, label: "Perfil", icon: UserRound },
] as const;

export function BottomNavigation() {
  return (
    <nav
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 glass"
      aria-label="Navegação principal"
    >
      <div className="container flex h-[70px] items-center justify-between">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className="relative flex flex-1 flex-col items-center justify-center gap-1 py-2 text-muted-foreground transition-colors"
          >
            {({ isActive }) => (
              <>
                <span className="relative flex h-8 w-12 items-center justify-center">
                  {isActive && (
                    <motion.span
                      layoutId="bottom-nav-pill"
                      className="absolute inset-0 rounded-xl bg-primary-50 dark:bg-primary-900/40"
                      transition={{ type: "spring", stiffness: 420, damping: 32 }}
                    />
                  )}
                  <Icon
                    className={cn("relative h-5 w-5 transition-transform", isActive && "scale-110 text-primary")}
                    strokeWidth={isActive ? 2.4 : 2}
                  />
                </span>
                <span className={cn("text-[11px] font-medium font-display", isActive && "text-primary")}>
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
